import { CloseRounded, FavoriteRounded, SpaRounded, TextsmsRounded } from '@mui/icons-material'
import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Slide, Typography, useTheme } from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import { ReactElement, Ref, forwardRef, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import logo from '../../../../../assets/Images/logos/logodark.svg'
import { subscribeToSeminarlesson } from '../../../../../redux/actions/seminarlessons'
import { IRootState } from '../../../../../redux/types'
import Login from '../../../../frontoffice/auth/ui/pages/Login'
import Register from '../../../../frontoffice/auth/ui/pages/Register'
import ButtonBack from '../../../../shared/components/buttons/ButtonBack'
import { CancelButton, SaveButton } from '../../../../shared/components/inputs'
import SuscriptionLive from '../../../../shared/components/inputs/SuscriptionLive'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import { formsStyles } from '../../../../shared/styles/FormsStyles'

const Transition = forwardRef(function Transition(props: TransitionProps & { children: ReactElement<any, any> }, ref: Ref<unknown>) {
  return <Slide direction="up" ref={ref} {...props} />
})

function TicketModal({ stateModal, handleClose }: any) {
  const theme = useTheme()
  const formClasses = formsStyles(theme)
  const isMobile = useScreenWidth(700)
  const dispatch = useDispatch()
  const { t } = useTranslation(['global'])

  const { isAuth, authFrom } = useSelector((state: IRootState) => state.auth)
  const { seminarlesson_selected } = useSelector((state: IRootState) => state.seminarlesson)
  const [showLogin, setShowLogin] = useState(false)
  const [showRegistration, setShowRegistration] = useState(false)

  useEffect(() => {
    if (seminarlesson_selected !== null && seminarlesson_selected.isRegistered !== null) handleClose(false)
  }, [seminarlesson_selected])

  useEffect(() => {
    if (isAuth && authFrom === 'seminar') dispatch(subscribeToSeminarlesson({ seminarlesson_id: seminarlesson_selected.id }))
  }, [isAuth])

  const handleGoBack = () => {
    setShowRegistration(false)
    setShowLogin(false)
  }

  return (
    <Dialog
      open={stateModal}
      fullWidth={true}
      fullScreen={isMobile && true}
      maxWidth={!showLogin && !showRegistration && isMobile ? false : 'sm'}
      sx={formClasses.containerForm}
      TransitionComponent={Transition}
      onClose={() => {
        handleClose(false)
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Grid container alignItems="center" justifyContent={!showLogin && !showRegistration ? 'flex-end' : 'space-between'}>
          {!showLogin && !showRegistration ? (
            <Button
              onClick={() => {
                handleClose(false)
              }}
              color="primary"
              variant="text"
            >
              <CloseRounded />
            </Button>
          ) : (
            <>
              <img src={logo} height="24" alt="logo" />
              <ButtonBack customFunction={handleGoBack} goBack={false} async={false} />
            </>
          )}
        </Grid>
      </DialogTitle>
      <DialogContent sx={formClasses.bodyFormLink}>
        <Grid container alignItems="center" justifyContent={!showLogin && !showRegistration ? 'flex-end' : 'space-between'}>
          {isAuth ? (
            <SuscriptionLive />
          ) : (
            !showLogin &&
            !showRegistration && (
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                height={isMobile ? '90%' : 'auto'}
                maxWidth={350}
                gap={16}
                pb={2}
                mx="auto"
              >
                <Typography variant="h6">{t('client.seminars.register-to-watch-this-seminar-text')}</Typography>
                <SaveButton autoFocus id="btn-handlelogin" startIcon={<FavoriteRounded />} onClick={() => setShowLogin(true)}>
                  {t('client.seminars.do-you-have-user-login-text', {
                    APP_NAME: import.meta.env.VITE_NAME
                  })}
                </SaveButton>
                <SaveButton
                  id="btn-handlelogin"
                  sx={formClasses.singup}
                  startIcon={<SpaRounded />}
                  onClick={() => setShowRegistration(true)}
                >
                  {t('client.seminars.dont-you-have-user-register-text', {
                    APP_NAME: import.meta.env.VITE_NAME
                  })}
                </SaveButton>
                <SaveButton
                  id="btn-handlelogin"
                  startIcon={<TextsmsRounded />}
                  style={{ padding: '10px 16px' }}
                  onClick={() => setShowLogin(true)}
                >
                  {t('client.seminars.do-you-have-user-dont-remember-password-text')}
                </SaveButton>
                <CancelButton
                  sx={formClasses.inscription}
                  onClick={() => {
                    handleClose(false)
                  }}
                >
                  {t('cancel')}
                </CancelButton>
              </Box>
            )
          )}
          {showLogin && <Login authFrom={'seminar'} />}
          {showRegistration && <Register authFrom={'seminar'} />}
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default TicketModal
